@for (star of starArray(); track $index) {
<span class="star-icon" [ngClass]="star.type" style="position: relative; display: inline-block">
  @if (star.type === 'partial') {
  <span class="star-fill" [style.width.%]="star.percentage">&#9733;</span>
  }
  <span [style.color]="star.type === 'empty' || star.type === 'partial' ? '#e0e0e0' : '#ffd700'"
    >&#9733;</span
  >
</span>
}
